import store from 'config/store'
import { path, pathOr } from 'ramda'

export const getEmbedPathOr = (defaultValue: any, path:string[]) => {
  const { embed = {} } = store.getState()
  return pathOr(defaultValue, path, embed)
}

export const getEmbedConfiguration = (state) => {
  return path(['embed','configuration'],state)
}
